export function SiteFooter() {
  return (
    <footer className="site-footer">
      <p>One button. Every press sets a new minimum.</p>
      <nav aria-label="Legal navigation">
        <a href="/terms">Terms</a>
        <a href="/privacy">Privacy</a>
        <a href="/refunds">Refunds</a>
        <a href="/acceptable-use">Acceptable use</a>
        <a href="/security">Security</a>
      </nav>
      <p className="fine-print">No prize. No investment. No guaranteed traffic.</p>
    </footer>
  );
}
